import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import isAdmin from '../shared/hoc/isAdmin';
import DrainPipePanel from './drainPipe/DrainPipePanel';
import HelpPanel from './help/HelpPanel';
import ProductPanel from './product/ProductPanel';
import ProjectTemplatePanel from './projectTemplate/ProjecteTemplatePanel';
import SoilPanel from './soil/SoilPanel';

interface IBackofficeProps {}

const Panel = styled(TabPanel)`
    padding: 19px;
`;

const Backoffice = (props: IBackofficeProps) => {
    const [value, setValue] = React.useState('1');

    const { t } = useTranslation();

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', typography: 'body1', flex: 1 }}>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label='lab API tabs example'>
                        <Tab variant='standard' label={t('products')} value='1' />
                        <Tab variant='standard' label={t('soils')} value='2' />
                        <Tab variant='standard' label={t('drainPipes')} value='3' />
                        <Tab variant='standard' label={t('projectTemplate')} value='4' />
                        <Tab variant='standard' label={t('help')} value='5' />
                    </TabList>
                </Box>
                <Panel value='1'>
                    <ProductPanel />
                </Panel>
                <Panel value='2'>
                    <SoilPanel />
                </Panel>
                <Panel value='3'>
                    <DrainPipePanel />
                </Panel>
                <Panel value='4'>
                    <ProjectTemplatePanel />
                </Panel>
                <Panel value='5'>
                    <HelpPanel />
                </Panel>
            </TabContext>
        </Box>
    );
};

export default isAdmin(Backoffice);
